import CommonFeature from "../../components/common/common.feature";
import AboutHero from "./components/about.hero";
import AboutInsta from "./components/about.insta";
import AboutIntro from "./components/about.intro";
import ContactUs from "./components/contact.us";

export default function AboutUs() {
  //   const { isOpenBuyNowModal } = useSelector((state) => state.modal);

  return (
    <article className="about-us">
      <AboutHero />
      <CommonFeature className="--about-us" />
      <AboutIntro />
      <ContactUs />
      {/* <AboutInsta /> */}
    </article>
  );
}
